import { useLang } from "../i18n/LanguageContext";

export function LanguageSwitcher({ testId = "language-switcher" }) {
  const { lang, setLang } = useLang();
  const langs = ["en", "es"];
  return (
    <div
      className="flex items-center gap-1 rounded-full border border-border bg-cream/60 p-1 backdrop-blur"
      role="group"
      aria-label="Language selector"
      data-testid={testId}
    >
      {langs.map((l) => (
        <button
          key={l}
          type="button"
          onClick={() => setLang(l)}
          aria-pressed={lang === l}
          data-testid={`${testId}-${l}`}
          className={`min-w-[40px] rounded-full px-3 py-1.5 text-xs font-semibold uppercase tracking-widest transition-colors duration-300 ${
            lang === l ? "bg-charcoal text-cream" : "text-charcoal/60 hover:text-charcoal"
          }`}
        >
          {l}
        </button>
      ))}
    </div>
  );
}
